import { FiatOrderSet } from '@exodus/models'

export default function createInitialState({ defaultFiatAmount }) {
  return {
    fiatAmount: String(defaultFiatAmount),
    isEmptyFromAmount: false,
    assets: {
      data: {},
      loaded: false,
    },
    config: {
      data: {},
      loaded: false,
    },
    countries: {
      data: {},
      loaded: false,
    },
    hiddenFailedFiatOrderNotifications: {},
    orders: {
      data: FiatOrderSet.fromArray([]),
      loaded: false,
    },
    user: {
      authenticated: false,
      kyc: {},
    },
  }
}
